export enum AccountType {
    LOCAL = 'LOCAL',
    SSO = 'SSO',
}
